import { watch, toValue, onScopeDispose, type WatchSource } from 'vue';

const getScrollBarWidth = (): number => {
    return window.innerWidth - document.documentElement.clientWidth;
};


/**
 * Composable that locks body scroll when `isLocked` is true.
 * Handles scroll bar width compensation to prevent layout shift.
 * @param isLocked - Reactive ref or getter indicating lock state
 */
export const useBodyLock = (isLocked: WatchSource<boolean>): void => {
    let originalOverflow = '';
    let originalPaddingRight = '';

    const lock = (): void => {
        const scrollBarWidth = getScrollBarWidth();

        originalOverflow = document.body.style.overflow;
        originalPaddingRight = document.body.style.paddingRight;

        document.body.style.overflow = 'hidden';

        if (scrollBarWidth > 0) {
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        }
    };

    const unlock = (): void => {
        document.body.style.overflow = originalOverflow;
        document.body.style.paddingRight = originalPaddingRight;
    };

    watch(
        isLocked,
        (locked) => {
            if (locked) {
                lock();
            }
            else {
                unlock();
            }
        }
    );

    onScopeDispose(() => {
        if (toValue(isLocked)) {
            unlock();
        }
    });

    // start
    if (toValue(isLocked)) {
        lock();
    }
};
